import { t } from 'i18next';
import { ROUTES } from 'vio-constants';
export function getCurrentKEXViewName(pathname) {
    if (pathname.includes(ROUTES.ACTIVE_CONNECTIONS)) {
        return t('ACTIVE_CONNECTIONS', {
            ns: 'Common'
        });
    }
    if (pathname.includes(ROUTES.COMMUNITY)) {
        return t('COMMUNITY', {
            ns: 'Common'
        });
    }
    if (pathname.includes(ROUTES.PROFILE)) {
        return t('MY_PROFILE', {
            ns: 'Common'
        });
    }
    return '';
}
export function isActiveConnectionsView(pathname) {
    return pathname.includes(ROUTES.ACTIVE_CONNECTIONS);
}
export function isCommunityView(pathname) {
    return pathname.includes(ROUTES.COMMUNITY);
}
export function isProfileView(pathname) {
    return pathname.includes(ROUTES.PROFILE);
}
export function isOrgKEXParticipant(organization, consumerAPI) {
    if (consumerAPI) {
        const { enrolled_in_kex } = organization;
        return enrolled_in_kex;
    }
    const { kex_participant } = organization;
    return kex_participant;
}
